var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "rpd-page", attrs: { fluid: "" } },
    [
      _c("header", { staticClass: "query-page-header" }, [
        _c("div", { staticClass: "query-page-copy" }, [
          _c("div", { staticClass: "query-page-eyebrow" }, [
            _vm._v("Relative percent difference"),
          ]),
          _vm._v(" "),
          _c("h1", [_vm._v("Compare a sample with its duplicate")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Pair a primary sample with its field duplicate, confirm the acceptance criteria, then\n        generate a workbook. Every calculation is written to the workbook rather than shown here.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "query-page-actions" },
          [
            _c(
              "v-btn",
              {
                staticClass: "my-2",
                on: {
                  click: function ($event) {
                    _vm.drawer = true
                  },
                },
              },
              [
                _c("v-icon", { attrs: { left: "", color: "info" } }, [
                  _vm._v("folder_open"),
                ]),
                _vm._v("\n        Load saved query\n      "),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              { staticClass: "my-2", on: { click: _vm.openSaveDialog } },
              [
                _c("v-icon", { attrs: { left: "", color: "info" } }, [
                  _vm._v("save"),
                ]),
                _vm._v("\n        Save query\n      "),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "query-workspace" },
        [
          _c(
            "v-layout",
            [
              _c("RpdSavedQueriesDrawer", {
                attrs: {
                  drawer: _vm.drawer,
                  queries: _vm.savedQueries,
                  loading: _vm.savedQueriesLoading,
                  unavailable: _vm.savedQueriesUnavailable,
                },
                on: {
                  "update:drawer": function ($event) {
                    _vm.drawer = $event
                  },
                  "load:query": _vm.loadQuery,
                  "delete:query": _vm.deleteQuery,
                },
              }),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "pt-0", staticStyle: { "min-width": "0" } },
                [
                  _c("div", { staticClass: "query-summary" }, [
                    _c("div", { staticClass: "query-summary-copy" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.savedQueryName || "New query")),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.statusText))]),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "field-note" }, [
                      _vm._v(
                        "\n            Accepting RPD > " +
                          _vm._s(_vm.thresholds.acceptanceThreshold) +
                          "% fails a row.\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.resolving || _vm.generating
                    ? _c("v-progress-linear", {
                        staticClass: "my-0",
                        attrs: { height: 4, color: "info", indeterminate: "" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    { staticClass: "rpd-card" },
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "rpd-tabs",
                          attrs: { "slider-color": "info" },
                          model: {
                            value: _vm.tab,
                            callback: function ($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab",
                          },
                        },
                        [
                          _c(
                            "v-tab",
                            { attrs: { href: "#rpd-pairing" } },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("call_split"),
                              ]),
                              _vm._v(
                                "\n              Sample pairing\n            "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            { attrs: { href: "#rpd-criteria" } },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("tune"),
                              ]),
                              _vm._v(
                                "\n              Criteria & exclusions\n            "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tab,
                            callback: function ($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            { attrs: { value: "rpd-pairing" } },
                            [
                              _c(
                                "div",
                                { staticClass: "pairing" },
                                [
                                  _c("div", { staticClass: "section-head" }, [
                                    _c("h2", [_vm._v("Sample pairing")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "section-lede" }, [
                                    _vm._v(
                                      "\n                  Each side runs its own filter set. Fill in the primary sample's filters on the\n                  left and the duplicate's on the right.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("RpdVerdictBand", {
                                    attrs: { band: _vm.band },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pairing__sides" },
                                    [
                                      _c("RpdPairingFilters", {
                                        attrs: {
                                          side: "primary",
                                          filter: _vm.pairing.Primary,
                                          locations: _vm.locations,
                                          aliases: _vm.primaryAliases,
                                          "media-types": _vm.mediaTypes,
                                        },
                                        on: {
                                          "update:filter": function ($event) {
                                            return _vm.setSide(
                                              "Primary",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("RpdPairingFilters", {
                                        attrs: {
                                          side: "duplicate",
                                          filter: _vm.pairing.Duplicate,
                                          locations: _vm.locations,
                                          aliases: _vm.duplicateAliases,
                                          "media-types": _vm.mediaTypes,
                                          "collision-note": _vm.identity
                                            .collides
                                            ? "Both sides point at this location."
                                            : "",
                                        },
                                        on: {
                                          "update:filter": function ($event) {
                                            return _vm.setSide(
                                              "Duplicate",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pairing__actions" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "field-note" },
                                        [_vm._v(_vm._s(_vm.confirmNote))]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "spacer" }),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "info",
                                            disabled: _vm.resolving,
                                            loading: _vm.resolving,
                                          },
                                          on: { click: _vm.confirmFilters },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("search")]
                                          ),
                                          _vm._v(
                                            "\n                    Confirm filter\n                  "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            { attrs: { value: "rpd-criteria" } },
                            [
                              _c("RpdCriteriaExclusions", {
                                attrs: {
                                  thresholds: _vm.thresholds,
                                  "excluded-analyte-ids":
                                    _vm.excludedAnalyteIds,
                                  catalogue: _vm.analyteCatalogue,
                                  loading: _vm.catalogueLoading,
                                },
                                on: {
                                  "update:thresholds": function ($event) {
                                    _vm.thresholds = $event
                                  },
                                  "update:excludedAnalyteIds": function (
                                    $event
                                  ) {
                                    _vm.excludedAnalyteIds = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("RpdResolvedSamples", {
                    attrs: {
                      resolution: _vm.resolution,
                      identity: _vm.identity,
                      band: _vm.band,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: { type: "info", dismissible: "" },
                      model: {
                        value: _vm.submitted,
                        callback: function ($$v) {
                          _vm.submitted = $$v
                        },
                        expression: "submitted",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Report generation request is submitted. Please check the status of the process at the\n          "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "field-note__link",
                          on: { click: _vm.goToMessageCenter },
                        },
                        [_vm._v("message center")]
                      ),
                      _vm._v(".\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-actions card-actions--foot" },
                    [
                      _c("span", { staticClass: "export-notes" }, [
                        _c(
                          "span",
                          { staticClass: "field-note card-actions__note" },
                          [_vm._v(_vm._s(_vm.exportNote))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "spacer" }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "info",
                            disabled: !_vm.canGenerate,
                            loading: _vm.generating,
                          },
                          on: { click: _vm.onExport },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("file_download"),
                          ]),
                          _vm._v("\n            Generate workbook\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("RpdSaveQueryDialog", {
        attrs: {
          "saved-queries": _vm.savedQueries,
          "current-user-id": _vm.currentUserId,
          "initial-name": _vm.savedQueryName,
          "initial-shared": _vm.savedQueryShared,
          "initial-description": _vm.savedQueryDescription,
          busy: _vm.saving,
        },
        on: { save: _vm.onSave },
        model: {
          value: _vm.saveDialog,
          callback: function ($$v) {
            _vm.saveDialog = $$v
          },
          expression: "saveDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }